import { render, staticRenderFns } from "./betSlip.vue?vue&type=template&id=b54ec1ee&lang=pug&"
import script from "./betSlip.vue?vue&type=script&lang=js&"
export * from "./betSlip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports